let cacheBuster = new Date().getTime();

function cloneWithCacheBuster(filters) {
    cacheBuster += 1;
    return Object.assign({}, filters, { cacheBuster });
}

function handlePagination(filters) {
    if (!filters.pageNumberChanged) {
        delete filters.pageNumber;
    }
    delete filters.pageNumberChanged;
}

export function query(data = {}) {
    return Object.keys(data)
        .filter(key => typeof data[key] !== 'undefined' && data[key] !== null)
        .map(key =>
            Array.isArray(data[key])
                ? data[key].map(val => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&')
                : `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join('&');
}

export function pollQuery(filterState, oldProgress, pollingTimeout) {
    const filters = cloneWithCacheBuster(filterState);

    handlePagination(filters);

    if (pollingTimeout) {
        filters.pollingTimeOut = pollingTimeout;
    }
    // Progress is needed for the server to send 304 Not Modified for unchanged poll results,
    // see no.finn.travel.flight.storage.client.StatusBuilder
    filters.progress = oldProgress;

    return query(filters);
}

export function filterQuery(filterState, filterData) {
    const filters = cloneWithCacheBuster(filterState);

    // Handle checkbox filters that supports all being unchecked
    if (filters.airlines !== undefined) {
        if (filters.airlines.length < 2 || filters.airlines.split(',').length === filterData.airlines.length) {
            delete filters.airlines;
        }
    }
    if (filters.stopoverAirports) {
        filters.stopoverAirports =
            filters.stopoverAirports.split(',').length === filterData.stopoverAirports.airports.length
                ? undefined
                : filters.stopoverAirports;
    }

    handlePagination(filters);

    return query(filters);
}
